<template>
  <NuxtLayout name="default">
    <div class="ticket_container">
      <div
        class="brand"
        style="margin-top: 20px">
        <a
          href="/"
          title="展会网"
          target="_blank">
          聚展
        </a>
        <el-icon>
          <ArrowRight />
        </el-icon>
        <a
          href="/wiki"
          title="展会百科"
          target="_blank">
          展会百科
        </a>
        <el-icon>
          <ArrowRight />
        </el-icon>
        <a
          :href="`/wiki/${fair.exhibitionId}-${historyId}-0-0.html`"
          target="_blank"
          :title="fair.exhibitionAlias">
          {{ fair.exhibitionAlias }}
        </a>
      </div>
      <div class="ticket_context">
        <div class="ticket_left">
          <div class="top_content">
            <div class="exh_detail_basic_info box_top">
              <div class="exh_detail_right">
                <div>
                  <div class="row-flex jsb">
                    <h1 class="detail_name">{{ fair.exhibitionAlias }}</h1>
                    <div>
                      <span style="font-size: 14px; font-weight: normal">
                        更新时间：{{ updateTime }}
                      </span>
                    </div>
                  </div>

                  <h2
                    class="detail_en"
                    style="margin-top: 6px">
                    {{ fair.exhibitionName }}
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div class="content-section range box">
            <div class="">
              <RichImgLazy
                :htmlContent="getContent(fair.introduction, fair.exhibitionId)"
                classTag="exh_range" />
            </div>
          </div>

          <div
            class="content-section history box"
            v-if="historyFairList.length > 0">
            <section-title
              h2
              style="font-size: 18px"
              title="历届展会" />
            <div class="history_list row-flex-wrap">
              <div
                class="news-left"
                v-for="item in historyFairList"
                :key="item.exhibitionId">
                <div class="news-cover">
                  <NuxtLink
                    :to="`/wiki/${item.exhibitionId}-${item.id || 0}-1-${historyId}.html`"
                    :title="item.newsName"
                    target="_blank">
                    <img
                      v-webp
                      :data-src="formatLogo(item.logo)"
                      :alt="item.name"
                      rel="nofollow,noindex" />
                  </NuxtLink>
                </div>
                <div class="news-info">
                  <p class="name">
                    <span>
                      <NuxtLink
                        :to="`/wiki/${item.exhibitionId}-${item.id || 0}-1-${historyId}.html`"
                        :title="item.name"
                        target="_blank">
                        {{ item.name }}
                      </NuxtLink>
                    </span>
                  </p>
                  <p class="time">
                    <span style="margin-right: 15px">
                      {{ item.startTime }} -
                      {{ item.endTime ? item.endTime.slice(5) : '' }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="content-section fair-info box">
            <div class="base-info row-flex-wrap">
              <div class="base-info-item row-flex">
                <h2 class="label">中 文 名</h2>
                <div class="value">
                  <NuxtLink
                    :to="`/exhibition/${fair.exhibitionId}.html`"
                    target="_blank">
                    {{ fair.exhibitionName }}
                  </NuxtLink>
                </div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">举办地点</h2>
                <div class="value">
                  {{ pavilionAddress }}
                </div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">简　　称</h2>
                <div class="value">{{ fair.exhibitionEnglishName }}</div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">举办时间</h2>
                <div class="value">
                  {{ fair.startTime }} -
                  {{ fair.endTime ? fair.endTime.slice(5) : '' }}
                </div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">主办单位</h2>
                <div class="value">{{ fair.organizer }}</div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">举办展馆</h2>
                <div class="value">
                  <NuxtLink
                    :to="`/pavilion/${pavilionInfoId}.html`"
                    target="_blank">
                    {{ pavilionName }}
                  </NuxtLink>
                </div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">观众数量</h2>
                <div class="value">{{ fair.audience }}</div>
              </div>
              <div class="base-info-item row-flex">
                <h2 class="label">展商数量</h2>
                <div class="value">{{ fair.exhibitors }}</div>
              </div>
            </div>
          </div>

          <div
            class="content-section fair-image box"
            v-if="fairImage.length > 0">
            <section-title
              h2
              style="font-size: 18px; margin-bottom: 5px"
              :title="`${fair.exhibitionAlias || ''}现场图片`" />
            <div class="fair-image-box row-flex-wrap">
              <div
                v-for="item in fairImage"
                :key="item"
                class="medium_item">
                <img
                  v-lazy="`${item + getXOssWebpSize({ w: 264, h: 200 })}`"
                  :alt="fair.exhibitionName"
                  preview="0"
                  rel="nofollow,noindex" />
              </div>
            </div>
          </div>

          <div
            class="content-section industry-fair box"
            v-if="fairNews.length > 4">
            <div class="head">参考资料</div>
            <div class="industry-list">
              <div
                v-for="(item, index) in fairNews.slice(4)"
                :key="item.newsId"
                class="industry-item row-flex">
                <div class="name ellipsis">
                  {{ index + 1 }}
                  <NuxtLink
                    :to="`/information/${item.newsId}.html`"
                    target="_blank">
                    {{ item.newsName }}
                  </NuxtLink>
                  <span class="time">{{ item.publishTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ticket_right">
          <div class="fair-cover">
            <img
              :src="formatLogo(fair.logo)"
              :alt="fair.exhibitionName" />
          </div>
          <div
            class="wiki_tag box"
            style="margin: 0">
            <p>热门百科</p>
            <div class="wiki_tag_list row-flex-wrap">
              <div
                class="wiki_tag_item"
                v-for="item in hotWikiList"
                :key="item.id">
                <NuxtLink
                  :to="`/wiki/${item.exhibitionId}-${item.id || 0}-0-0.html`"
                  :title="item.exhibitionAliasName"
                  target="_blank">
                  {{ item.exhibitionAliasName }}
                </NuxtLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="recommend_exh industry-news-box"
        v-if="fairNews.length > 0">
        <div class="industry-news-box__header title_more">
          <section-title
            h2
            style="font-size: 20px; font-weight: bold"
            :title="fair?.exhibitionAlias + $t('menu.exhibitionInfo')" />
          <p class="more">
            <a
              style="cursor: pointer; display: flex; align-items: center"
              @click="goToInformation()">
              {{ $t('common.more') }}
              <el-icon size="16">
                <ArrowRight />
              </el-icon>
            </a>
          </p>
        </div>
        <div class="industry-news-box__top">
          <div
            class="news-left"
            v-for="news in fairNews.slice(0, 4)"
            :key="news.newsId">
            <div class="news-cover">
              <NuxtLink
                :to="handleNewsUrl(news.viewUrl, news.newsId)"
                :title="news.newsName"
                target="_blank">
                <img
                  v-webp
                  :data-src="news.logo"
                  :alt="news.newsName"
                  rel="nofollow,noindex" />
              </NuxtLink>
            </div>
            <div class="news-info">
              <p class="name">
                <i
                  style="width: 24px"
                  class="el-icon-toutiao"></i>
                <span>
                  <NuxtLink
                    :to="handleNewsUrl(news.viewUrl, news.newsId)"
                    :title="news.newsName"
                    target="_blank">
                    {{ news.newsName }}
                  </NuxtLink>
                </span>
              </p>
              <p class="time">
                <span style="margin-right: 15px">
                  {{ news.publishTime }}
                </span>
                <i
                  style="width: 12px; margin-right: 4px"
                  class="el-icon-look"></i>
                <span>{{ news.views || 0 }}</span>
              </p>
              <div class="content">
                {{ news.description }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hot_country">
        <div class="tab_head row-flex">
          <div
            class="tab_name"
            :class="{ active: innerChainActive == 0 }"
            @click="handleHotTab(0)">
            热门地区
          </div>
          <div
            class="tab_name"
            :class="{ active: innerChainActive == 1 }"
            @click="handleHotTab(1)">
            热门行业
          </div>
          <div
            class="tab_name"
            :class="{ active: innerChainActive == 2 }"
            @click="handleHotTab(2)">
            热门展会
          </div>
        </div>
        <div class="country_list">
          <div
            class="tab_content row-flex-wrap"
            v-show="innerChainActive == 0">
            <a
              v-for="item in innerChainAreaList"
              :key="item.id"
              :href="item.url"
              target="_blank"
              :title="item.content">
              {{ item.content }}
            </a>
          </div>
          <div
            class="tab_content row-flex-wrap"
            v-show="innerChainActive == 1">
            <a
              v-for="item in innerChainIndustryList"
              :key="item.id"
              :href="item.url"
              target="_blank"
              :title="item.content">
              {{ item.content }}
            </a>
          </div>
          <div
            class="tab_content row-flex-wrap"
            v-show="innerChainActive == 2">
            <a
              v-for="item in innerChainExhList"
              :key="item.id"
              :href="item.url"
              target="_blank"
              :title="item.content">
              {{ item.content }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, computed } from 'vue'
  import { ArrowRight } from '@element-plus/icons-vue'
  import { useWikiDetail } from '~/composables/wiki/useWikiDetail'
  import { ELocale } from '~~/types/enums'
  import _ from 'lodash'

  const RichImgLazy = defineAsyncComponent(() => import('~/components/richImgLazy/index.vue'))

  const SectionTitle = defineAsyncComponent(() => import('~/components/SectionTitle/index.vue'))

  // 获取路由参数
  const route = useRoute()
  const {
    id,
    a: historyId = '0',
    h: historyStatus = '0',
    aid: exhibitionAliasId = '0'
  } = route.params

  // 使用 composable - SSR 模式下直接调用 fetchData
  const {
    fair,
    fairImage,
    historyFairList,
    hotWikiList,
    fairNews,
    innerChainActive,
    innerChainAreaList,
    innerChainIndustryList,
    innerChainExhList,
    title,
    langApi,
    updateTime,
    fetchData,
    handleHotTab,
    goToInformation,
    getContent,
    getXOssWebpSize,
    formatLogo,
    formatIndustry,
    xss,
    handleNewsUrl,
    $t
  } = await useWikiDetail(
    id as string,
    historyId as string,
    historyStatus as string,
    exhibitionAliasId as string,
    ELocale.cn
  )

  // SSR 模式下直接获取数据
  await fetchData()

  // 计算属性
  // const pavilionPicture = computed(() => {
  //   const val = _.get(fair.value, 'pavilionInfo.picture', '')
  //   try {
  //     return val.split(';')
  //   } catch (e) {
  //     return [val]
  //   }
  // })
  const pavilionInfoId = ref(_.get(fair.value, 'pavilionInfo.id', ''))
  const pavilionName = ref('')
  pavilionName.value = `${
    _.get(fair.value, 'pavilionInfo.pavilionName', null) ||
    _.get(fair.value, 'pavilionInfo.pavilionEnglishName', null)
  }`
  const pavilionAddress = ref('')
  pavilionAddress.value =
    fair.value.regionType == 1
      ? _.get(fair.value, 'pavilionInfo.pavilionEnglishAddress', '')
      : _.get(fair.value, 'pavilionInfo.pavilionAddress', '')

  // const center = computed(() => {
  //   return [
  //     _.get(fair.value, 'pavilionInfo.latitude', 0),
  //     _.get(fair.value, 'pavilionInfo.longitude', 0)
  //   ]
  // })

  // 页面头部设置 - SSR 模式
  useHead({
    title,
    meta: [
      {
        name: 'keywords',
        content: `${fair.value.exhibitionAlias || ''},${fair.value.exhibitionName || ''}`
      },
      {
        name: 'description',
        content: fair.value.introduction
          ? fair.value.introduction.replace(/<[^>]*>/g, '').slice(0, 100)
          : ''
      }
    ]
  })
</script>

<style lang="less" scoped>
  .ticket_container {
    .font {
      font-size: 12px;
    }
    .box_top {
      background: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .box {
      background: #fff;
      margin-top: 20px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    }
    .form_required {
      margin-bottom: 8px;
      .required {
        color: #ff3a3a;
        font-size: 14px;
      }
    }

    .back {
      padding: 12px 0 12px 0;
      width: 1190px;
      margin: auto;
    }
    .brand {
      width: 1190px;
      font-size: 14px;
      line-height: 16px;
      padding: 8px;
      border-radius: 4px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      margin: auto;
      background: #fff;
      display: flex;
      align-items: center;
      a {
        font-size: 14px;
      }
    }
    .ticket_context {
      padding-top: 20px;
      width: 1190px;
      display: flex;
      margin: auto;
      .ticket_left {
        width: 854px;
        border-radius: 4px;
        margin-right: 20px;
        .top_content {
          margin: 0 auto;
          position: relative;

          .exh_detail_basic_info {
            display: flex;
            padding: 20px;
            border-radius: 4px;

            .exh_detail_right {
              display: flex;
              flex-direction: column;
              flex: 1;
              position: relative;
              width: 536px;

              .detail_name {
                width: 600px;
                font-size: 24px;
                font-weight: bold;
                line-height: 26px;
                display: flex;
                align-items: flex-start;

                h1 {
                  font-size: 20px;
                  font-weight: bold;
                  line-height: 26px;
                }

                .tag {
                  height: 26px;
                  line-height: 26px;
                  font-style: normal;
                  font-size: 16px;
                  border-radius: 4px;
                  padding: 0 6px;
                  margin-right: 6px;
                  flex-shrink: 0;
                  color: #fff;
                }

                .tag[data-tag='推荐'] {
                  background: linear-gradient(#ff6337, #ff381a);
                }

                .tag[data-tag='精选'] {
                  background: linear-gradient(#39dd80, #1cb84a);
                }

                .tag[data-tag='热门'] {
                  background: linear-gradient(#37b0fe, #1d7cfe);
                }
              }

              .del {
                display: block;
                color: #999 !important;
                text-decoration: line-through;

                div {
                  text-decoration: line-through;
                }
              }

              .weight {
                font-weight: bold;
              }

              .new-date {
                display: flex;
                align-items: center;

                .el-icon-xin {
                  margin-right: 6px;
                }
              }

              .detail_en {
                font-size: 18px;
                font-weight: 600;
                line-height: 18px;
                margin-bottom: 12px;
              }

              .exh_close {
                margin-right: 8px;
                width: 74px;
                height: 26px;
                background: url('~/assets/icon/closeExh.webp') no-repeat;
              }

              .exh_change {
                margin-right: 8px;
                width: 100px;
                height: 26px;
                background: url('~/assets/icon/timeChange.webp') no-repeat;
              }

              .exh_delay {
                margin-right: 8px;
                width: 74px;
                height: 26px;
                background: url('~/assets/icon/delay.webp') no-repeat;
              }
            }
          }
        }
        .content-section,
        .service-area,
        .exhibitor_image,
        .fair-info,
        .range,
        .history,
        .fair-image,
        .industry-fair,
        .industry-news-box {
          background: #fff;
          margin-top: 20px;
          padding: 20px;
        }
        .fair-info {
          .base-info {
            .base-info-item {
              width: 402px;
              border-bottom: dashed 1px #aaa;
              min-height: 40px;
              .label {
                width: 80px;
                flex-shrink: 0;
                padding: 10px 0;
                font-weight: normal;
                font-size: 16px;
              }
              .value {
                padding: 10px 0;
                padding-right: 10px;
              }
            }
          }
        }
        .history {
          .history_list {
            gap: 10px;
            margin-top: 10px;
          }
          .news-left {
            width: 402px;
            display: flex;
            background: #fff;
            border-radius: 6px;

            &:nth-child(2n) {
              margin-right: 0;
            }

            .news-cover {
              width: 140px;
              height: 100px;
              display: flex;
              justify-content: center;
              align-items: center;
              overflow: hidden;
              border: 1px solid #ddd;
              margin-right: 10px;
              border-radius: 4px;
              flex-shrink: 0;

              img {
                width: 140px;
                height: 100px;
                object-fit: cover;
              }
            }

            .news-info {
              width: calc(100% - 150px);
              height: 100%;

              .name {
                font-size: 16px;
                font-weight: bold;
                color: #333;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }

              .time {
                display: flex;
                font-size: 14px;
                color: #999;
                margin-top: 10px;
              }
            }
          }
        }
        .exh_range {
          p {
            margin: 8px 0;
          }
        }
        .fair-image {
          .fair-image-box {
            gap: 10px;
          }
          .medium_item {
            width: 264px;
            height: 200px;
            flex-shrink: 0;
            border-radius: 10px;
            background: #f7f7f7;
            overflow: hidden;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            img {
              width: 264px;
              height: auto;
              min-height: 200px;
              border-radius: 10px;
            }
          }
        }
        .industry-fair {
          .head {
            padding: 5px 0;
            color: #333;
            font-size: 16px;
            font-weight: bold;
            border-bottom: solid 2px #ccc;
          }
          .industry-list {
            .industry-item {
              margin-top: 10px;
              gap: 10px;
              color: #666;
              .name {
                font-size: 12px;
              }
              .time {
                font-size: 12px;
                color: #aaa;
              }
            }
          }
        }

        .inner_content {
          width: 854px;
          margin: 0 auto;
        }
        .pavilion {
          font-size: 16px;
          color: #666;
          line-height: 28px;
          margin-top: 14px;

          .pavilion_name {
            font-weight: bold;
            color: #333;
            .info-item_button {
              padding: 6px 10px;
              border-radius: 5px;
              font-size: 14px;
              font-family:
                PingFangSC-Medium,
                PingFang SC,
                sans-serif;
              font-weight: 400;
              cursor: pointer;
              background: #e50113;
              color: #fff;
            }
          }
          .pavilion_address {
            margin-top: 10px;
          }

          .pavilion-area {
            display: flex;

            .img_con {
              width: 390px;
              height: 297px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 6px;
              transform: translateZ(0);
              overflow: hidden;

              img {
                width: 390px;
                min-width: 390px;
                height: 297px;
                border-radius: 6px;
                transform: translateZ(0);
              }
            }

            :deep(.el-carousel) {
              width: 390px;
              border-radius: 6px;
              transform: translateZ(0);
              overflow: hidden;
            }

            :deep(.pavilion_map) {
              width: 408px !important;
              transform: translateZ(0);

              &:only-child {
                width: 100%;
              }
            }
          }
        }
      }
      .ticket_right {
        width: 316px;
        flex-shrink: 0;
        .fair-cover {
          width: 316px;
          height: 260px;
          margin-bottom: 20px;
          flex-shrink: 0;
          border-radius: 4px;
          overflow: hidden;

          img {
            width: 316px;
            height: 260px;
            object-fit: cover;
            transition: all 0.3s;
          }
          &:hover {
            img {
              transform: scale(1.2);
            }
          }
        }
        .wiki_tag {
          padding: 20px;
          > p {
            color: #000;
            font-weight: bold;
          }
          .wiki_tag_list {
            margin-top: 10px;
            gap: 10px;
            .wiki_tag_item {
              padding: 2px 5px;
              font-size: 14px;
              background: #6cb8ff;
              color: #fff;
              border-radius: 4px;
              a {
                color: #fff;
              }
            }
          }
        }

        .form_label,
        .form_item_label :deep(.el-form-item__label) {
          width: 64px;
          color: #333;
          font-size: 14px;
          padding-right: 0;
        }
        .form_item_label {
          display: flex;
          :deep(.el-form-item__content) {
            flex: 1;
          }
        }
      }
    }
  }

  .recommend_exh {
    width: 1190px;
    margin: 0 auto 10px;

    .title_more {
      display: flex;
      margin-bottom: 6px;

      .more {
        margin-left: auto;
        font-size: 16px;
        font-weight: 400;
        color: #333;
      }
    }

    .recommend_exh_list {
      display: flex;
      flex-wrap: wrap;

      .exh_item {
        margin-right: 12px;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }
    .news-left {
      width: 565px;
      display: flex;
      align-items: center;
      background: #fff;
      border-radius: 6px;

      &:nth-child(2n) {
        margin-right: 0;
      }

      .news-cover {
        width: 200px;
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        border: 1px solid #ddd;
        margin-right: 10px;
        border-radius: 4px;
        flex-shrink: 0;

        img {
          width: 200px;
          height: 100px;
          object-fit: cover;
        }
      }

      .news-info {
        width: calc(100% - 210px);
        height: 100%;
        padding: 4px 0;

        .name {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }

        .time {
          display: flex;
          font-size: 14px;
          color: #999;
          margin-top: 10px;
        }

        .content {
          padding-top: 5px;
          line-height: 24px;
          font-size: 14px;
          color: #666;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
        }
      }
    }
  }

  .industry-news-box {
    margin-top: 20px;
    padding: 20px;
    background: #fff;
    border-radius: 4px;

    .industry-news-box__top {
      display: flex;
      flex-wrap: wrap;
      gap: 20px;
    }
  }

  .hot_country {
    width: 1190px;
    margin: 20px auto;
    padding: 20px;
    background: #fff;
    border-radius: 6px;
    .tab_head {
      gap: 10px 20px;
      margin-bottom: 10px;
      .tab_name {
        padding-bottom: 3px;
        font-size: 15px;
        border-bottom: solid 2px #fff;
        &.active {
          border-bottom: solid 2px @app-color;
        }
        &:hover {
          cursor: pointer;
        }
      }
    }
    .tab_content {
      gap: 10px;
    }
    .country_list {
      a {
        font-size: 15px;
        color: #333;
        min-width: 129px;

        &:nth-child(8n) {
          margin-right: 0;
        }
      }
    }
  }
</style>

<style lang="less" scoped>
  :deep(.el-input__inner) {
    background: transparent;
  }

  :deep(.el-upload),
  :deep(.cover) {
    width: 316px;
    height: 200px;
    line-height: 200px;
    border-radius: 8px;
  }

  .submit {
    width: 100%;
    padding: 32px 0 70px;
  }

  :deep(.el-form-item) {
    margin-bottom: 18px;
  }
</style>
